import Axios, { AxiosRequestHeaders } from "axios";
import {
  getAccessToken,
  setAccessTokenMe,
} from "sr/helpers/functions/setAccessTokenMe";
import { getCookieValue } from "../helper";
import { getRegionId, waitForRegionId } from "sr/helpers/functions/setCityMe";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { deleteCookies } from "sr/helpers/functions/deleteCookies";

const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
const noTokenNeed = ["/auth/", "/auth/reset"];
const excludedRegionApis = [
  "/user/switch-user",
  "/user/register-target-type",
  "/cleaner?id",
  "/company?id",
  "/individual?id",
  "/region",
];
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.post["Content-Type"] = "application/json";

axios.interceptors.request.use(
  async (config) => {
    // Inject it into the custom header for your Express backend

    const requirePath = !noTokenNeed.some((item) => config.url?.includes(item));
    const copy = { ...config };
    const path = config.url || "";
    if (requirePath) {
      const accessToken = getAccessToken(); //get the LATEST token here
      const shouldSetRegion =
        path !== "/user" &&
        !excludedRegionApis.some((excludedPath) => path.includes(excludedPath));
      const getDetails = getUserDetails();
      if (
        shouldSetRegion &&
        getDetails?.user_id &&
        (getDetails?.userType === "cleaner" ||
          getDetails?.userType === "individual")
      ) {
        const regionId = await waitForRegionId();
        if (regionId) {
          (copy.headers as AxiosRequestHeaders)["user-region-id"] = regionId;
        }
      }
      (
        copy.headers as AxiosRequestHeaders
      ).Authorization = `Bearer ${accessToken}`;
    }
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // console.log("userTimeZone", userTimeZone);
    (copy.headers as AxiosRequestHeaders)["x-user-timezone"] = userTimeZone;

    const ua = window.navigator.userAgent;
    // Determine the name instantly
    const name = ua.includes("Edg/")
      ? "Edge"
      : ua.includes("OPR/")
      ? "Opera"
      : ua.includes("Chrome/")
      ? "Chrome"
      : ua.includes("Firefox/")
      ? "Firefox"
      : ua.includes("Safari/")
      ? "Safari"
      : "Unknown";
      console.log("user agent name", name);
      
    (copy.headers as AxiosRequestHeaders)["device-type"] = "web";
    (copy.headers as AxiosRequestHeaders)["device-model"] = name;

    return copy;
  },
  async (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  async (response) => {
    if (response.data.error == null) {
      return response;
    }
    return Promise.reject(response);
  },

  async (error) => {
    const originalRequest = error.config;
    const isRefreshRequest = originalRequest.url.includes("/auth/refreshjwt");
    const isNoTokenRequest = noTokenNeed.some((item) =>
      originalRequest.url?.includes(item),
    );

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !isRefreshRequest &&
      !isNoTokenRequest
    ) {
      originalRequest._retry = true;
      try {
        const refreshToken = getCookieValue("refreshToken");
        const res = await axios.get(`/auth/refreshjwt`, {
          headers: {
            Authorization: `Bearer ${refreshToken}`,
          },
        });
        if (res?.data?.jwt) {
          setAccessTokenMe(res?.data?.jwt);
          if (typeof res?.data?.onBoardingStatus === "boolean") {
            const userdetails = getUserDetails();
            localStorage.setItem(
              "auth",
              JSON.stringify({
                ...userdetails,
                onBoardingStatus: res.data.onBoardingStatus,
              }),
            );
          }
          const regionId = getRegionId();
          originalRequest.headers.Authorization = `Bearer ${res?.data?.jwt}`;
          if (regionId) {
            (originalRequest.headers as AxiosRequestHeaders)["user-region-id"] =
              regionId;
          }
          return axios(originalRequest);
        } else {
          const getDetails = getUserDetails();
          if (
            getDetails?.user_id &&
            (getDetails?.userType === "cleaner" ||
              getDetails?.userType === "individual")
          ) {
            deleteCookies("refreshToken");
            localStorage.removeItem("auth");
            window.location.href = "/auth"; // Redirect to login
          }
        }
      } catch (err) {
        console.error("Refresh failed");
        const getDetails = getUserDetails();
        if (
          getDetails?.user_id &&
          (getDetails?.userType === "cleaner" ||
            getDetails?.userType === "individual" ||
            getDetails?.userType === "company")
        ) {
          deleteCookies("refreshToken");
          localStorage.removeItem("auth");
          window.location.href = "/auth"; // Redirect to login
        }
        return Promise.reject(err);
      }
    }

    if (error.response && error.response.status >= 400) {
      console.error("Bad Request Error:");
      console.error("Response data:", error.response.data);
      console.error("Response headers:", error.response.headers);
      return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);

export default axios;
